<template>
  <RatingInfo
    v-if="reviewsSummaryResponse"
    anchor-id="reviews"
    :rating="reviewsSummaryResponse"
  />
</template>

<script setup lang="ts">
import { useFetchReviewsSummary } from '~/scopes/product-core/composables/useFetch/useFetchReviewsSummary/useFetchReviewsSummary'
import RatingInfo from '~/scopes/reviews/reviews-display/components/Rating/Rating.vue'

const { data: reviewsSummaryResponse } = useFetchReviewsSummary()
</script>
